module.exports = __webpack_public_path__ + "media/Lane Hall Section 2.d32cd137.mp3";